// extracted by mini-css-extract-plugin
module.exports =  {"videoPlayer":"nzLUtMN6iSgOmJxei7nZ"};